import Immutable from 'immutable'
import * as BASE_ACTION from '../constants/types/baseTypes'
import * as USER_ACTION from '../constants/types/userTypes'
import * as LOTTERY_ACTION from '../constants/types/lotteryTypes'
import {stateStructure} from './_stateStructure.js'
import { setCookie, getCookie, delCookie } from '../helpers/unit'

const initialState = Immutable.fromJS( stateStructure.base );

export default function base( state = initialState, action ){

	let _state = state.toJS();
	switch (action.type) {
		case BASE_ACTION.SAY_HELLO: {
			_state.welcome = 'hello world'
			return state.merge(_state);
		}
		// 打开OVERLAY
		case BASE_ACTION.OVERLAY_OPEN:{
			_state.modal.overlay.display = true;
			return state.merge(_state);
		}
		// 关闭OVERLAY
		case BASE_ACTION.OVERLAY_CLOSE:{
			_state.modal.overlay.display = false;
			return state.merge(_state);
		}
		// 打开手机版导航左右侧导航菜单
		case BASE_ACTION.NAVIGATOR_OPEN:{
			_state.modal.natigator.display = true;
			return state.merge(_state);
		}
		// 关闭手机版导航左右侧导航菜单
		case BASE_ACTION.NAVIGATOR_CLOSE:{
			_state.modal.natigator.display = false;
			return state.merge(_state);
		}
		// 打开ALERT
		case BASE_ACTION.ALERT_OPEN:{
			_state.modal.alert = {
				display: true,
				text: action.options.text,
				callback: action.options.callback,
				delay: action.options.delay,
				title: action.options.title,
				buttonText: action.options.buttonText,
				params: action.options.params
			};
			_state.modal.overlay.display = true;
			return state.merge(_state);
		}
		// 关闭ALERT
		case BASE_ACTION.ALERT_CLOSE:{
			_state.modal.alert.display = false;
			_state.modal.alert.text = null;
			_state.modal.alert.delay = null;
			_state.modal.overlay.display = false;
			return state.merge(_state);
		}
		// 打开CONFIRM
		case BASE_ACTION.CONFIRM_OPEN:{
			_state.modal.confirm = {
				display: true,
				text: action.options.text,
				confirm: action.options.confirm,
				cancel: action.options.cancel,
				title: action.options.title,
				params: action.options.params,
				className: action.options.className,
				extendButtons: action.options.extendButtons,
				confirmBtnText: action.options.confirmBtnText
			};
			_state.modal.overlay.display = true;
			return state.merge(_state);
		}
		// 关闭CONFIRM
		case BASE_ACTION.CONFIRM_CLOSE:{
			_state.modal.confirm.display = false;
			_state.modal.overlay.display = false;
			return state.merge(_state);
		}
		// 显示LOADING
		case BASE_ACTION.LOADING_OPEN:{
			_state.modal.loading.display = true;
			_state.modal.loading.text = action.text;
			return state.merge(_state);
		}
		// 关闭LOADING
		case BASE_ACTION.LOADING_CLOSE:{
			_state.modal.loading.display = false;
			return state.merge(_state);
		}
		// 服务层切换路由
		case BASE_ACTION.ROUTER_CHANGE:{
			window.location.href = action.options.uri;
			return state.merge(_state);
		}
		// 生成随机数
		case BASE_ACTION.RANDOM_MAKER: {
			_state.ui.random = _.random(10000);
			return state.merge(_state);
		}
		// 播放声音
		case BASE_ACTION.PLAY_SOUND:{
			// 用户设置不播放声音
			if (!_state.config.soundNotice) {
				return state;
			}
			_state.sound = action.options;
			return state.merge(_state);
		}
		// 停止播放声音
		case BASE_ACTION.STOP_SOUND:{
			_state.sound = {
				play: false
			};
			return state.merge(_state);
		}
		// 打开拖拽IFRAME
		case BASE_ACTION.OPEN_DRAG_FRAME:{
			_state.dragFrame.display = true;
			_state.dragFrame.url = action.url;
			return state.merge(_state);
		}
		// 关闭拖拽IFRAME
		case BASE_ACTION.CLOSE_DRAG_FRAME:{
			_state.dragFrame.display = false;
			return state.merge(_state);
		}
		// 打开小提示
		case BASE_ACTION.OPEN_TOAST:{
			_state.toast.display = true;
			_state.toast.message = action.message;
			_state.toast.className = action.className;
			return state.merge(_state);
		}
		// 关闭小提示
		case BASE_ACTION.CLOSE_TOAST:{
			_state.toast.display = false;
			return state.merge(_state);
		}
		// 打开中奖通知
		case BASE_ACTION.START_WINNER_NOTICE:{
			_state.config.winnerNotice = true;
			delCookie('notice-winner')
			return state.merge(_state);
		}
		// 关闭中奖通知
		case BASE_ACTION.STOP_WINNER_NOTICE:{
			_state.config.winnerNotice = false;
			setCookie('notice-winner', 0, 7*24*3600)
			return state.merge(_state);
		}
		// 打开关闭投注动画
		case BASE_ACTION.TOGGLE_DISPLAY_ANIMATION:{
			if (action.status) {
				_state.config.showBetAnimation = true;
				delCookie('show-bet-animation')
			}else{
				_state.config.showBetAnimation = false;
				setCookie('show-bet-animation', 0, 7*24*3600)
			}
			state.merge(_state);
		}
		// 打开声音提示
		case BASE_ACTION.START_SOUND_NOTICE:{
			_state.config.soundNotice = true;
			delCookie('notice-sound')
			return state.merge(_state);
		}
		// 关闭声音提示
		case BASE_ACTION.STOP_SOUND_NOTICE:{
			_state.config.soundNotice = false;
			setCookie('notice-sound', 0, 7*24*3600)
			return state.merge(_state);
		}
		// 打开余额显示 
		case BASE_ACTION.SHOW_BALANCE:{
			_state.config.showBalance = true;
			delCookie('show-balance')
			return state.merge(_state);
		}
		// 关闭余额显示
		case BASE_ACTION.HIDE_BALANCE:{
			_state.config.showBalance = false;
			setCookie('show-balance', 0, 7*24*3600)
			return state.merge(_state);
		}
		//切换背景图片
		case BASE_ACTION.SKINNING:{
			_state.ui.skin = action.options.skin
			return state.merge(_state);
		}
		// 切换彩种的时候判断是否需要切换背景
		case LOTTERY_ACTION.SET_WINDOW_METHOD:{
			// 需要切换的彩种
			const needSwitchLottery = ['jssm', 'pk10']
			if (_.includes(needSwitchLottery, action.data.flag)) {
				_state.ui.skin = action.data.flag + '-bg';
			}else{
				_state.ui.skin = getCookie('skin') || 'sc-background-01';
			}
			_state.dragFrame.display = false;
			return state.merge(_state);
		}
		// 退出投注页的时候切换背景
		case LOTTERY_ACTION.CLEAR_WINDOW_METHOD:{
			_state.ui.skin = getCookie('skin') || 'sc-background-01';
			return state.merge(_state);
		}
		// 显示界面
		case BASE_ACTION.SHOW_UI:{
			_state.ui.display = true;
			return state.merge(_state);
		}
		// 广告合集
    case BASE_ACTION.ADS_RECOMMEND: {
			_state.ads = _.chain(action.result.data || []).sortBy('sort').value()
			return state.merge(_state);
    }
		// 注销用户
		case USER_ACTION.LOGOUT:{
			const keepAlert = _state.modal.alert;
			const keepOverlay = _state.modal.overlay;
			const keepConfig = _state.config;
			const keepUi = _state.ui;
			const ads = _state.ads;
			_state = initialState.toJS();
			_state.modal.alert = keepAlert;
			_state.modal.overlay = keepOverlay;
			_state.config = keepConfig;
			_state.ui = keepUi;
			_state.ads = ads;
			$.delCookie('stay_status');
			$.delCookie('_sessionHandler');
			$.delCookie('u');
			const MOBILE_REX = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i;
	    if (MOBILE_REX.test(navigator.userAgent) && window.vers !== 'df') {
	      window.location.href = "/webapp/#/welcome";
    	}else{
    		window.location.href = "/#/login";
    	}
			return state.merge(_state);
		}
		// 打开IFRAME MODAL
		case BASE_ACTION.IFRAME_MODAL_OPEN:{
			_state.modal.iframe = {
				display: true,
				text: action.options.text,
				url: action.options.url,
				width: action.options.width,
				height: action.options.height
			};
			return state.merge(_state);
		}
		// 关闭IFRAME MODAL
		case BASE_ACTION.IFRAME_MODAL_CLOSE:{
			_state.modal.iframe.display = false;
			return state.merge(_state);
		}
		// 打开转账弹窗
		case BASE_ACTION.TRANSFER_MODAL_OPEN:{
			_state.modal.transfer = {
				display:true,
				platform:action.options.platform,
				url:action.options.url
			}
			return state.merge(_state);
		}
		// 关闭转账弹窗
		case BASE_ACTION.TRANSFER_MODAL_CLOSE:{
			_state.modal.transfer.display = false;
			return state.merge(_state);
		}
		default:
      		return state;
	}
}